import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Logo } from './ui';

interface HeaderProps {
  scrollToRef: (ref: React.RefObject<HTMLDivElement>) => void;
  contactRef: React.RefObject<HTMLDivElement>;
  openRolesRef: React.RefObject<HTMLDivElement>;
}

const Header: React.FC<HeaderProps> = ({ scrollToRef, contactRef, openRolesRef }) => {
  return (
    <header className="flex h-20 w-full items-center px-4 md:px-6 bg-gray-800 text-white">
      <RouterLink className="flex items-center gap-2" to="#">
        <Logo color="white" />
        <span className="text-lg font-semibold">FF Automaton</span>
      </RouterLink>
      <nav className="ml-auto flex gap-4">
        <RouterLink className="text-sm font-medium hover:text-gray-300" to="#">
          Docs
        </RouterLink>
        <RouterLink
          className="text-sm font-medium hover:text-gray-300"
          to="#contact"
          onClick={(e) => {
            e.preventDefault();
            scrollToRef(contactRef);
          }}
        >
          Contact
        </RouterLink>
        <RouterLink
          className="text-sm font-medium hover:text-gray-300"
          to="#open-roles"
          onClick={(e) => {
            e.preventDefault();
            scrollToRef(openRolesRef);
          }}
        >
          Join Us
        </RouterLink>
      </nav>
    </header>
  );
};

export default Header;